module.exports = __webpack_public_path__ + "img/contribute.bd009e2d.svg";